// Regras do comprovante do malote (#5788), sem I/O — rodam sob `node --test`.
// O acesso ao storage fica em maloteAgrupamentoStorage.ts.
//
// O bucket é PRIVADO: o documento tem carimbo e assinatura de quem
// recebeu na Prefeitura, então nada de URL pública (o `tarefas-anexos` é público — ver a regra de
// anexos de projeto). A leitura é sempre por link assinado, que expira.

export const BUCKET_MALOTES = 'malotes-agrupamento';

/** 10 MB: comprovante é foto ou PDF de uma folha; acima disso é engano. */
export const TAMANHO_MAXIMO_MB = 10;

const TIPOS_ACEITOS = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];

/** Recusa antes de subir, com a frase que a tela mostra. `null` = pode enviar. */
export function motivoArquivoRecusado(arquivo: File): string | null {
  if (arquivo.size > TAMANHO_MAXIMO_MB * 1024 * 1024) {
    return `O arquivo tem ${(arquivo.size / 1024 / 1024).toFixed(1)} MB e o limite é ${TAMANHO_MAXIMO_MB} MB.`;
  }
  if (arquivo.type && !TIPOS_ACEITOS.includes(arquivo.type)) {
    return 'Envie o comprovante em PDF, JPG, PNG ou WEBP.';
  }
  return null;
}

/**
 * Comprovante de retenção do pagamento (#6003). Mesmo bucket privado do malote, com prefixo
 * próprio: as políticas são do bucket inteiro, então não há política nova para manter, e os dois
 * comprovantes do mesmo mês não se sobrescrevem.
 */
export function caminhoComprovanteRetencao(agrupamentoId: number, fechamentoId: number, nomeArquivo: string): string {
  const ext = (nomeArquivo.split('.').pop() || 'pdf').toLowerCase().replace(/[^a-z0-9]/g, '') || 'pdf';
  return `${agrupamentoId}/retencao-${fechamentoId}-${Date.now()}.${ext}`;
}

/**
 * Anexo da nota fiscal da competência (#5791). Mesmo bucket privado, prefixo próprio: as
 * políticas são do bucket inteiro, e NF, malote e comprovante de retenção não se sobrescrevem.
 */
export function caminhoAnexoNf(agrupamentoId: number, fechamentoId: number, nomeArquivo: string): string {
  const ext = (nomeArquivo.split('.').pop() || 'pdf').toLowerCase().replace(/[^a-z0-9]/g, '') || 'pdf';
  return `${agrupamentoId}/nf-${fechamentoId}-${Date.now()}.${ext}`;
}

/** Caminho estável: um comprovante por fechamento, agrupado por Secretaria. */
export function caminhoComprovante(agrupamentoId: number, fechamentoId: number, nomeArquivo: string): string {
  const ext = (nomeArquivo.split('.').pop() || 'pdf').toLowerCase().replace(/[^a-z0-9]/g, '') || 'pdf';
  return `${agrupamentoId}/${fechamentoId}-${Date.now()}.${ext}`;
}
